module.exports = __webpack_public_path__ + "static/result-empty.f88b46a3.png";